/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Aria_Desktop_MenuInputs */

const en_nav_aria_desktop_menu = /** @type {(inputs: Nav_Aria_Desktop_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desktop navigation menu`)
};

const es_nav_aria_desktop_menu = /** @type {(inputs: Nav_Aria_Desktop_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menú de navegación de escritorio`)
};

/**
* | output |
* | --- |
* | "Desktop navigation menu" |
*
* @param {Nav_Aria_Desktop_MenuInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const nav_aria_desktop_menu = /** @type {((inputs?: Nav_Aria_Desktop_MenuInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Aria_Desktop_MenuInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_nav_aria_desktop_menu(inputs)
	return en_nav_aria_desktop_menu(inputs)
});